/* Quick add for the product page's "Complete your setup" cards (blocks/st-setup.liquid). The round
   add button posts its option to /cart/add.js, asks for the cart sections in the same request and
   announces a CartLinesUpdateEvent, the event Horizon's own Add to cart uses, so the cart drawer
   redraws and opens as it does after the main button. Without JavaScript the button submits its
   form to /cart/add. */
if (!customElements.get('st-quick-add')) {
  customElements.define(
    'st-quick-add',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', (event) => {
          const button = event.submitter || event.target.querySelector('[data-st-add]');
          if (!button?.dataset.stAdd) return;
          event.preventDefault();
          this.#addLine(event.target, button);
        });
      }

      async #addLine(form, button) {
        const error = this.querySelector('[data-st-error]');
        if (error) error.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const root = window.Shopify?.routes?.root || '/';
        const json = (r) => {
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        };
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((c) => c.dataset.sectionId);
          const id = Number(button.dataset.stAdd);
          // A preorder variant's form carries the Preorder property (snippets/st-preorder.liquid).
          const properties = {};
          form.querySelectorAll('input[data-st-prop]').forEach((input) => {
            const name = input.name.match(/^properties\[(.+)\]$/)?.[1];
            if (name) properties[name] = input.value;
          });
          const added = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id, quantity: 1, ...(Object.keys(properties).length ? { properties } : {}) }],
              ...(sections.length ? { sections: sections.join(','), sections_url: window.location.pathname } : {}),
            }),
          }).then(json);
          const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then(json);
          const deferred = CartLinesUpdateEvent.createPromise();
          form.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(id), quantity: 1 }],
              promise: deferred.promise,
            })
          );
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { sections: added.sections, items: cart.items, itemCount: cart.item_count, source: 'st-quick-add', didError: false },
          });
        } catch (e) {
          if (error) error.hidden = false;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
